import { Converter } from '../types/converter';

export const electricResistivityConverter: Converter = {
  id: 'electricResistivity',
  name: 'Electric Resistivity Converter',
  icon: 'Zap',
  categories: ['electricity'],
  units: [
    // Base SI unit
    { name: 'Ohm meter', symbol: 'Ω·m', factor: 1 },

    // Common variants
    { name: 'Ohm centimeter', symbol: 'Ω·cm', factor: 0.01 },
    { name: 'Ohm inch', symbol: 'Ω·in', factor: 0.0254 },
    { name: 'Microhm centimeter', symbol: 'µΩ·cm', factor: 1e-8 },
    { name: 'Microhm inch', symbol: 'µΩ·in', factor: 2.54e-8 },

    // CGS units
    { name: 'Abohm centimeter', symbol: 'abΩ·cm', factor: 1e-11 },
    { name: 'Statohm centimeter', symbol: 'stΩ·cm', factor: 8.987552e9 },

    // Other units
    { name: 'Circular mil ohm/foot', symbol: 'cmil·Ω/ft', factor: 1.662426e-9 },
  ],
};
